<template>
  <div class="banner">
    <div class="center">
      <p class="h1">专业的商业大数据解决方案供应商</p>
      <p class="h3">数量化追踪，预测，数据审计</p>
      <el-button @click="showDetail">开始使用</el-button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {}
    },
    methods: {
      showDetail: function () {
        this.$router.push('direction')
      }
    },
    computed: {
      ...mapState(['test'])
    }
  }
</script>

<style lang="scss" scoped>
  $backgroundColor: #06223a;
  @import "../styles/app";
  .banner{
    @include  setWh(100%,36.3rem);
    background-color: $backgroundColor;
    padding: 0;
    margin: 0;
    position: relative;
    .center {
      position:absolute;
      height: 27rem;
      top: 0;
      right:0;
      bottom: 0;
      left: 0;
      margin: auto;
      .h1, .h3, button {
        margin: 0 auto;
        text-align: center;
        display: block;
        color: #d1dddc;
        font-weight: 100;
      }
      .h1 {
        font-size: 5rem;
        margin-bottom: 4.2rem;
      }
      .h3 {
        font-size: 3.2rem;
        margin-bottom: 7.8rem;
      }
      button {
        width: 21.4rem;
        height: 5.2rem;
        border: 1px solid #d1dddc;
        background-color: $backgroundColor;
        font-size: 2rem;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/banner.vue